import React, { useEffect, useState } from "react";

import "popper.js";
import "bootstrap/dist/js/bootstrap";
import { useHistory } from "react-router-dom";
// Componentes
import Foto from "../element/Foto";
import HeaderMenu from "../element/HeaderMenu";
import Menu from "../componentes/Menu";
import dataSuper from "../hooks/Conf";
import dataDireccionEstudiantil from '../hooks/useDireccionEstudiantil';
import CarAlumnoDatos from '../element/CarAlumnoDatos';
// Contexto
// import dataContext from "../context/User";
// Helper
import GetFetch from "../helper/GetFetch";
import loadMenu from "../js/main";
import Footer from "../componentes/Footer";

import "../css/styleAdmin.css";
// import { data } from 'jquery';

const CargosMorasCC = () => {
  const history = useHistory();

  const [cargos, setCargos] = useState({});
  const [moras, setMoras] = useState(0);
  const [morasTitulos, setMorasTitulos] = useState();
  const [carnet, setCarnet] = useState({});
  const [alumno, setAlumno] = useState({});

  // const dataUser = useContext(dataContext);
  let datos = localStorage.getItem("dataUser");

  if (!datos) {
    history.push("/");
  }

  datos = JSON.parse(datos);

  if (dataSuper.indexOf(datos.carnet.trim()) === -1) {
    if (dataDireccionEstudiantil.indexOf(datos.carnet.trim()) === -1) {
      history.push("/");
    }
  }  

  let carnetSet = (e) => {
    setCarnet(e.target.value);
  };

  let onSutmit = (e) => {
    e.preventDefault();
    localStorage.setItem("currentCarnet", carnet);

    document.getElementById('dataContenedorAlumno').style.display = 'block';
    AlumnoDatos()

    let cargo = GetFetch.getCargosMorasBiblio(carnet, datos.token);
    let mora = GetFetch.getMorasBiblio(carnet, datos.token);
    let mt = GetFetch.getMorasTitulosBiblio(carnet, datos.token);

    Promise.all([cargo, mora, mt]).then((values) => {
      setCargos(values[0]);
      setMoras(values[1][0].valor);
      setMorasTitulos(values[2]);
    });
  };

  let AlumnoDatos = () => {
    let datosAlum = GetFetch.datosAlumno(carnet, datos.token);
    datosAlum.then((data) => {
      if (data[0]) {
        setAlumno(data[0]);
      }
    });
  };

  useEffect(() => {
    let currentCarnet = localStorage.getItem("currentCarnet");
    if (currentCarnet) {
      setCarnet(currentCarnet);
    } else {
      setCarnet("");
    }
    loadMenu();
    document.getElementById("textCarnet").focus();
  }, []);

  const listaCargos = cargos.length > 0 ? cargos : [];
  const listaMorasTitulos = morasTitulos && morasTitulos.length > 0 ? morasTitulos : [];
  const totalCargo = listaCargos.reduce((suma, el) => suma + el.cargo_costo, 0);

  return (
    <div className="wrapper d-flex align-items-stretch">
      <nav id="sidebar">
        <div className="custom-menu">
          <button
            type="button"
            id="sidebarCollapse"
            className="btn btn-primary"
          >
            <i className="fa fa-bars"></i>
            <span className="sr-only">Toggle Menu</span>
          </button>
        </div>
        <div className="p-4">
          <Foto foto={datos.carnet} alt="Foto alumno" tamanio="rounded" />

          <HeaderMenu
            carnet={datos.carnet}
            nombre={datos.nombre}
            perfil={datos.perfil}
            carrera={datos.carrera}
            posicion="text-center"
          />

          <Menu />

          <Footer />
        </div>
      </nav>

      <div id="content" className="p-4 p-md-5 pt-5">
        <h2 className="mb-4">Cargos y moras <small className="text-muted">CCESEN</small></h2>

        <div className="card">
          <div className="card-body">
            <form id="formUP" onSubmit={onSutmit}>
              <div className="form-group">
                <label htmlFor="textCarnet">Carnet del alumno</label>
                <input
                  id="textCarnet"
                  type="text"
                  placeholder="Carnet"
                  className="form-control"
                  onChange={carnetSet}
                  autoFocus
                  value={carnet}
                />
              </div>
              <button type="submit" className="btn btn-primary">
                <i className="fa fa-search mr-2" aria-hidden="true"></i>
                Consultar
              </button>
            </form>
          </div>
        </div>

        <CarAlumnoDatos alumno={alumno} />

        <div className="esen-stat-grid">
          <div className="esen-stat esen-stat--hero" id="totalCargoMora">
            <div>
              <div className="esen-stat-value">${+totalCargo + +moras}</div>
              <div className="esen-stat-label">Total de mora + cargos</div>
            </div>
          </div>
          <div className="esen-stat">
            <div>
              <div className="esen-stat-value">${moras || 0}</div>
              <div className="esen-stat-label">Mora</div>
            </div>
          </div>
          <div className="esen-stat" id="co">
            <div>
              <div className="esen-stat-value">${totalCargo}</div>
              <div className="esen-stat-label">Cargos</div>
            </div>
          </div>
        </div>

        {listaMorasTitulos.length > 0 ? (
          <div className="card">
            <div className="card-header">
              <i className="fa fa-book mr-2" aria-hidden="true"></i>
              Títulos con mora
            </div>
            <div className="card-body">
              <div className="table-responsive">
                <table className="table">
                  <thead>
                    <tr>
                      <th scope="col">Título</th>
                      <th scope="col">Fecha del préstamo</th>
                      <th scope="col">Fecha de la devolución</th>
                      <th scope="col">Fecha real de devolución</th>
                    </tr>
                  </thead>
                  <tbody>
                    {listaMorasTitulos.map((element) => {
                      let prestamoFecha = new Date(element.dateadd);
                      let devolucionFecha = new Date(element.datedev);
                      let realDevolucionFecha = new Date(element.fechadevolucion);
                      return (
                        <tr key={element.dateadd}>
                          <td>{element.titulos}</td>
                          <td>{prestamoFecha.toLocaleString()}</td>
                          <td>{devolucionFecha.toLocaleString()}</td>
                          <td>
                            <span className="esen-chip esen-chip--warning">
                              <i className="fa fa-calendar" aria-hidden="true"></i>
                              {realDevolucionFecha.toLocaleString()}
                            </span>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        ) : null}

        {listaCargos.length > 0 ? (
          <div className="card">
            <div className="card-header">
              <i className="fa fa-usd mr-2" aria-hidden="true"></i>
              Cargos
            </div>
            <div className="card-body">
              <div className="table-responsive">
                <table className="table">
                  <thead>
                    <tr>
                      <th scope="col">Descripción</th>
                      <th scope="col">Fecha del cargo</th>
                      <th scope="col">Tipo</th>
                      <th scope="col" className="text-right">Cargo</th>
                    </tr>
                  </thead>
                  <tbody>
                    {listaCargos.map((element) => {
                      let fecha = new Date(element.cargo_fecha);
                      return (
                        <tr key={element.cargo_id}>
                          <td>{element.cargo_desc}</td>
                          <td>{fecha.toLocaleString()}</td>
                          <td>
                            <span className="esen-chip esen-chip--neutral">
                              {element.cargos_tipo_desc}
                            </span>
                          </td>
                          <td className="text-right">${element.cargo_costo}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default CargosMorasCC;
